
const isProductAlreadyInCart = (cartItems, product) => {
  return cartItems.find(i => i.id === product.id && i.colorId === product.colorId && i.type.id === product.typeId)
};

export default isProductAlreadyInCart;